import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { seoMeta } from './seoMetaData';

const Seo = ({ route }) => {
    const location = useLocation();
    const defaultTitle = 'GlobalsBid – Explore Global Tenders & Procurement Opportunities';
    const defaultDescription = 'GlobalsBid is your trusted portal to search, filter, and explore international tenders and bids.';
    
    const ogImages = [
        'https://www.globalsbid.com/static/media/GlaobalBidTitleImage.a977913313c1e697a467.png',
        'https://www.globalsbid.com/static/media/logo.a5ac189f247e30607d0c9f66fb9f4c1b.svg',
        'https://assets.landing.so/cdn-cgi/image/format=auto,width=730,height=548,f=auto,fit=cover/page/2f9780cf-1272-41ed-96e1-ab62ad40d418/ocb2dd'
    ];

    const targetRoute = route || location.pathname;
    const metadata = seoMeta[targetRoute] || { 
        title: defaultTitle, 
        description: defaultDescription, 
        keywords: 'tenders, bids, procurement, global tenders' 
    };

    const title = metadata.title;
    const description = metadata.description;
    const canonicalUrl = `https://www.globalsbid.com${location.pathname || targetRoute}`;
    const type = 'business.business';
    const siteName = 'Globalsbid';

    return (
        <Helmet>
            {/* HTML Lang */}
            <html lang="en" />
            
            {/* Standard SEO Meta */}
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <title>{title}</title>
            <meta name="description" content={description} />
            {metadata.keywords && <meta name="keywords" content={metadata.keywords} />}
            
            {/* Dynamic Canonical URL */}
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph Tags */}
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:description" content={description} />

            {/* Static OG Images */}
            {ogImages.map((img, index) => (
                <meta key={`og-${index}`} property="og:image" content={img} />
            ))}

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {ogImages[0] && <meta name="twitter:image" content={ogImages[0]} />}
        </Helmet>
    );
};

export default Seo;